import React, { useEffect } from 'react';
import posthog from 'posthog-js';
import { useLocation } from 'react-router-dom';

const PostHogProvider = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    // Initialize PostHog
    posthog.init(
      'phc_sTnWKldVCX5r3lpnuL8PmZtF6qZ0fokqikQdG9SwFzA', // Replace with your actual PostHog API key
      {
        api_host: 'https://us.i.posthog.com', // Use your PostHog instance URL if self-hosted
        capture_pageview: false, // We'll handle this manually
        person_profiles: 'identified_only'
      }
    );
  }, []);

  // Track page views when the route changes
  useEffect(() => {
    if (location) {
      posthog.capture('$pageview', {
        current_url: window.location.href,
      });
    }
  }, [location]);

  return <>{children}</>;
};

export default PostHogProvider;